import { Directive, ViewContainerRef, Input, OnDestroy, ComponentRef, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[appLazy],[app-lazy]'
})
export class LazyLoaderDirective implements OnDestroy {

    @Input()
    appLazy: string;

    @Input('appLazyData')
    metadata: any;

    @Input('appLazyDefault')
    default: string;

    @Output('appLazyOnLoading') appLazyOnLoading = new EventEmitter<boolean>();

    private _loading: boolean = false;
    set loading(value: boolean){
        this._loading = value;
        setTimeout(() => {
            this.appLazyOnLoading.emit(this._loading);
        });
    }

    get loading(){
        return this._loading;
    }

    componentRef: ComponentRef<any>;

    constructor(public viewContainerRef: ViewContainerRef) {

    }

    ngOnDestroy() {
        this.viewContainerRef.clear();
    }

}
